export const styles = (theme) => ({
  filterContainer: {
    padding: "10px 15px",
    paddingBottom: 0
  },
  searchBox2: {
    padding: 15,
    paddingBottom: 0
  },
  sideBarLabel: {
    marginBottom: 10,
    fontSize: 13,
    color: "#404040d1",
  },
  checkBoxContainer: {
    marginBottom: 3,
  },
  checkBoxContainerInner: {
    marginBottom: 3,
    marginLeft: 20,
  },
  sideBarDropdown: {
    backgroundColor: "white",
    borderRadius: 10,
    marginTop: 6,
  },
  checkBox: {
    width: 10,
    fontSize: "6px!important",
  },
  headerLabel: {
    display: "inline-block",
    fontSize: "13px",
    color: "black",
  },
  multiSelector: {
    backgroundColor: "#fff",
    "z-index": 10,
  },
});
